<div class="page-content">
    <div class="pages-container-img"></div>
    <div class="mat-toolbar-wl">
        <mat-toolbar class="pt-2 pb-6 pb-md-2">
            <mat-toolbar-row>
                <div class="container-fluid mx-0 mx-md-auto">
                    <img class="img-absolute" src="./assets/img/logo-main.svg" alt="">
                    <div class="row">
                        <div class="col-md-12 d-flex align-content-center justify-content-end px-0 px-md-1">
                            <div class="d-flex align-items-center justify-content-end pr-0 pr-md-5" (click)="restart()">
                                <a class="button-link-1 d-flex align-items-center">
                                    <mat-icon inline="true" class="mr-1">replay</mat-icon>
                                    <span class="text-color-2">Registrar otra lectura</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>

    <div class="container-fluid container-md d-flex align-items-center">
        <div class="row mx-0 no-gutters">
            <div class="col-12 col-md-6"></div>
            <div class="col-12 col-md-6">
                <div class="bg-white border-rounded-1 d-flex flex-column  align-items-center ml-0 ml-md-8"
                    style="margin-bottom: 80px;">
                    <p class="text-color-secondary font-title font-semi-bold mt-4">{{title}}</p>
                    <div class="step-style-1">
                        <mat-horizontal-stepper (selectionChange)="changeStep($event)" [disableRipple]="true"
                            [ngClass]="{'step-1': steps === 1, 'step-2': steps === 2, 'step-3': steps === 3}"
                            labelPosition="bottom" #stepper>
                            <mat-step state="lupa" disableRipple="true">
                                <ng-template matStepLabel>Valida tus datos</ng-template>
                                <div class="w-70">
                                    <form [formGroup]="clientForm" class="row" autocomplete="off">
                                        <div class="col-12 mb-3">
                                            <p class="mb-3 text-color-secondary mt-4">Tipo Documento</p>
                                            <div class="stype-select-1">
                                                <mat-form-field appearance="outline">
                                                    <mat-select formControlName="documentType" [disabled]="bloqueo"
                                                        (click)="validar()"
                                                        placeholder="Seleccione el tipo de documento"
                                                        (selectionChange)="documentTypeChanged($event)">
                                                        <mat-option *ngFor="let doc of docs" [value]="doc.value">
                                                            {{doc.description}}</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-12 mb-3">
                                            <p class="mb-3 text-color-secondary">Número Documento</p>
                                            <div class="style-input-1">
                                                <mat-form-field appearance="outline">

                                                    <!-- modify-->
                                                    <input matInput formControlName="documentNumber" clientCode
                                                        [readonly]="bloqueo" (click)="validar()"
                                                        placeholder="Ingresa tu número de documento"
                                                        [maxlength]="documentNumberMaxlength"
                                                        [minlength]="documentNumberMinlength">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-12 mb-3">
                                            <div class="d-flex align-items-center mb-1">
                                                <span class="text-color-secondary mr-1">Número de
                                                    cliente</span>
                                                <div style="cursor: pointer;" (click)="openDialogHelp1()">
                                                    <mat-icon class="text-color-primary"
                                                        [ngClass]="bloqueo?'bloqueado':'sin'">help_outline</mat-icon>
                                                </div>
                                            </div>
                                            <div class="style-input-1">
                                                <mat-form-field appearance="outline">
                                                    <input matInput formControlName="clientCode"
                                                        placeholder="Ingresa tu número de cliente" [readonly]="bloqueo"
                                                        (click)="validar()" maxlength="12"
                                                        (keypress)="soloNumeros($event)">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-12 mb-3">
                                            <div class="checkbox-without-riple">
                                                <mat-checkbox formControlName="clauseAccepted" [disabled]="bloqueo"
                                                    (click)="validar()">
                                                    <span class="text-color-secondary text-checkbox">He leído y acepto
                                                        las
                                                        <span class="text-color-primary font-bold text-checkbox"
                                                            [ngClass]="bloqueo?'bloqueado':'sin'"
                                                            (click)="openPolicyModal(1)">política de privacidad </span>y
                                                        <span class="text-color-primary font-bold text-checkbox"
                                                            [ngClass]="bloqueo?'bloqueado':'sin'"
                                                            (click)="openPolicyModal(2)">términos y condiciones.</span>
                                                    </span>
                                                </mat-checkbox>
                                            </div>
                                        </div>
                                        <div class="col-12 mb-4 d-flex justify-content-center">
                                            <div class="mt-4 captcha-responsive">
                                                <re-captcha #captchaRef="reCaptcha" siteKey="{{captchaKey}}"
                                                    formControlName="captcha">
                                                </re-captcha>
                                            </div>
                                        </div>
                                        <div class="col-12 mb-4 d-flex justify-content-center">
                                            <button mat-flat-button class="style-button-1 mt-2 w-60"
                                                [disabled]="bloqueo" (click)="validar();goToSecondStep()">
                                                <span>Continuar</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </mat-step>

                            <mat-step state="datos" disableRipple="true">
                                <ng-template matStepLabel>Registra tu lectura</ng-template>
                                <div class="w-80">
                                    <form [formGroup]="meterReadingForm" class="row w-100">
                                        <div class="col-12 px-0 mb-3">
                                            <div class="d-flex align-items-center bg-1 border-rounded-1 p-2">
                                                <mat-icon class="text-color-primary mr-2">error_outline</mat-icon>
                                                <p class="text-color-primary ">Puedes visualizar la manera correcta de
                                                    tomar la foto <span
                                                        style="cursor: pointer; text-decoration: underline;"
                                                        class="font-semi-bold" (click)="openDialogHelp2()">aquí</span>
                                                </p>
                                            </div>
                                        </div>

                                        <div class="row mb-4">
                                            <div class="col-12">
                                                <p class="text-color-secondary mb-3">1. Tómale una foto a tu
                                                    medidor, debe ser nítida.
                                                </p>
                                                <div class="create-choose-img">

                                                    <div *ngIf="meterReadingForm.get('base64Image').value"
                                                        class="capa-opacity-1"></div>
                                                    <img *ngIf="meterReadingForm.get('base64Image').value"
                                                        [src]="meterReadingForm.get('base64Image').value" alt="">


                                                    <div *ngIf="meterReadingForm.get('base64Image').value" class="view"
                                                        (click)="openDialogView(meterReadingForm.get('base64Image').value)">
                                                        <mat-icon style="color: #fff;">zoom_out_map</mat-icon>
                                                    </div>
                                                    <div class="control-content">
                                                        <p *ngIf="!meterReadingForm.get('base64Image').value"
                                                            class="text-color-secondary mb-2">Tamaño
                                                            máximo <span class="font-semi-bold"
                                                                style="color: var(--color-primary);">5MB</span></p>
                                                        <p *ngIf="meterReadingForm.get('base64Image').value"
                                                            class="mb-2" style="color: #fff;">
                                                            {{filename}}</p>
                                                        <div class="style-button-2 mat-elevation-z3">
                                                            <button type="button " mat-button
                                                                (click)="fileInput.click()"
                                                                (click)="fileInput.value = ''">
                                                                <div
                                                                    class="d-flex justify-content-center align-items-center">
                                                                    <mat-icon class="mr-2">cloud_upload</mat-icon>
                                                                    <span
                                                                        *ngIf="!meterReadingForm.get('base64Image').value">Subir
                                                                        imagen</span>
                                                                    <span
                                                                        *ngIf="meterReadingForm.get('base64Image').value">Cambiar
                                                                        imagen</span>
                                                                </div>
                                                            </button>
                                                            <input #fileInput type="file" style="display: none;"
                                                                formControlName="imagePath"
                                                                accept="image/jpg, image/png, image/jpeg"
                                                                (change)="getBase64($event)">
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="col-12">
                                                <p class="text-color-secondary mb-3">2. Ingresas el consumo
                                                    actual de su medidor.</p>
                                                <p class="text-color-secondary mb-3">Consumo actual(m3).</p>
                                                <div class="style-input-1 mb-3">
                                                    <mat-form-field appearance="outline" floatLabel=never>
                                                        <input matInput formControlName="value" onlyInteger
                                                            maxlength="6">
                                                    </mat-form-field>
                                                </div>
                                                <div class="d-flex align-items-center bg-2 border-rounded-1 p-2">
                                                    <mat-icon class="text-color-1 mr-2">help_outline</mat-icon>
                                                    <p class="text-color-1 ">Tener en cuenta que solo se podrá realizar
                                                        un registro por día.</p>
                                                </div>
                                                <div *ngIf="notify"
                                                    class="d-flex align-items-center bg-2 border-rounded-1 p-2 mt-2 fade-in">
                                                    <mat-icon class="text-color-1 mr-2">help_outline</mat-icon>
                                                    <p class="text-color-1 ">La imagen excede el tamaño permitido a 5mb.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12 px-0 mb-3">
                                            <div class="checkbox-without-riple">
                                                <mat-checkbox formControlName="commerceAccepted" [hidden]="isHiddenCommerce"
                                                    (click)="validar()">
                                                    <span class="text-color-secondary text-checkbox">Acepto
                                                        los
                                                        <span class="text-color-primary font-bold text-checkbox"
                                                            [ngClass]="bloqueo?'bloqueado':'sin'"
                                                            (click)="openPolicyModal(1)">fines comerciales
                                                        </span>
                                                    </span>
                                                </mat-checkbox>
                                            </div>
                                        </div>
                                    </form>
                                </div> 
                                <div class="row mx-0 mx-md-3 mx-md-2 pb-4 pb-md-0">
                                    <div class="col-6 px-0 text-sm-left text-md-left pr-1">
                                        <div class="style-button-3 d-inline-block pl-1">
                                            <button type="button" class="mat-elevation-z3" mat-button
                                                (click)="prev(stepper)">
                                                <div class="d-inline-flex justify-content-center align-items-center">
                                                    <mat-icon class="mr-1">navigate_before</mat-icon>
                                                    <span>Atras</span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="col-6 px-0 text-sm-right text-md-right pr-1">
                                        <div class="style-button-4 d-inline-block ">
                                            <button type="button" mat-button class="mat-elevation-z3"
                                                (click)="goToThirdStep()">
                                                <div class="d-flex justify-content-center align-items-center">
                                                    <mat-icon class="mr-2 material-icons material-icons-outlined">send
                                                    </mat-icon>
                                                    <span>Enviar</span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </mat-step>

                            <mat-step state="visa" disableRipple="true">
                                <ng-template matStepLabel>¡Listo!</ng-template>
                                <div class="p-1 mb-0 mb-md-4">
                                    <div class="w-80 elevation-custom-1 p-4 mb-3 mt-3">
                                        <p class="text-center text-color-primary mb-2">Fecha de emisión:</p>
                                        <p class="text-center text-color-secondary mb-3">{{ today |
                                            date:'dd/MM/yyyy'}}</p>
                                        <p class="text-center text-color-primary mb-2">Número de cliente:</p>
                                        <p class="text-center text-color-secondary mb-3">{{
                                            clientForm.get('clientCode').value }}
                                        </p>
                                        <p class="text-center text-color-primary mb-2">Consumo actual(m3):</p>
                                        <p class="text-center text-color-secondary mb-3">{{
                                            meterReadingForm.get('value').value }}
                                            m3
                                        </p>
                                        <p class="text-center text-color-primary mb-2">Imagen subida:</p>
                                        <div class="img-contet text-center border-rounded-1">
                                            <div style="width: 180px; height: 180px;" class="mx-auto">
                                                <img class="border-rounded-1" style="width: 100%; height: 100%"
                                                    [src]="meterReadingForm.get('base64Image').value" alt="">
                                            </div>
                                        </div>
                                        <p class="text-center text-color-primary mb-2" style="margin-top: 17px;">Fecha
                                            de próxima lectura:</p>
                                        <p class="text-center text-color-secondary mb-3">
                                            {{this.nextDate}} *
                                        </p>
                                        <p class="text-center text-color-third mb-2">*Puedes registrar la lectura de tu
                                        </p>
                                        <p class="text-center text-color-third mb-2" style="margin-top: -8px;">medidor
                                            en la fecha indicada</p>
                                    </div>
                                </div>
                                <div class="mt-0 mt-md-5 mb-3 d-flex justify-content-between ">

                                    <div class="style-button-3 mr-1 mr-md-5">
                                        <button type="button" class="mat-elevation-z3" style="padding: 0 3px;"
                                            mat-button (click)="download()">
                                            <div class="d-flex justify-content-center align-items-center">
                                                <mat-icon class="mr-1">save_alt</mat-icon>
                                                <span style="font-size: 13px;">Descargar PDF</span>
                                            </div>
                                        </button>
                                    </div>

                                    <div class="style-button-4">
                                        <button type="button" class="mat-elevation-z3" style="padding: 0 3px;"
                                            mat-button (click)="openDialogSendMail()">
                                            <div class="d-flex justify-content-center align-items-center">
                                                <mat-icon class="mr-1 material-icons material-icons-outlined">send
                                                </mat-icon>
                                                <span style="font-size: 13px;">Enviar por correo</span>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </mat-step>

                            <!-- Icon overrides. -->
                            <ng-template matStepperIcon="lupa">
                                <mat-icon>description</mat-icon>
                            </ng-template>
                            <ng-template matStepperIcon="datos">
                                <mat-icon>crop_original</mat-icon>
                            </ng-template>
                            <ng-template matStepperIcon="visa">
                                <mat-icon>payment</mat-icon>
                            </ng-template>

                        </mat-horizontal-stepper>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>